import { Geogebra } from '../types/geogebra';
import { ResourceType } from '../types/resource-type';
import { ResourceResponse } from '../types/resource-response';
import checkMissingLocale from '../utils/missing-locales';
import { mapPrintable } from './contents-mapper';

export const geogebraMapper = (
  response: ResourceResponse,
  locale: string,
  isBloqued: boolean,
  isStudent: boolean
): Geogebra => {
  const isNotSession = false;
  const printables = mapPrintable(response, isStudent, isNotSession);
  return {
    id: response.uuid,
    file: response.file?.href || '',
    isBloqued,
    language: locale,
    script: response.script,
    settings: response.settings,
    type: response.type as ResourceType,
    description: checkMissingLocale(response.description),
    title: checkMissingLocale(response.name),
    printables,
    tags: response.tags,
  };
};
